import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NotificationRow } from '../notifications.models';

/**
 * Content only: MatMenuItem is a component rather than a directive, so it cannot share a host element with
 * this one. The panel wraps it in an `a mat-menu-item` and the page in a plain anchor.
 */
@Component({
  selector: 'app-knowledge-notification-row',
  templateUrl: './notification-row.component.html',
  styleUrls: ['./notification-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotificationRowComponent {
  public readonly row = input.required<NotificationRow>();
}
